import { render, staticRenderFns } from "./MenuTemplate.vue?vue&type=template&id=2a6dbb1b&"
import script from "./MenuTemplate.vue?vue&type=script&lang=js&"
export * from "./MenuTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MenuTemplate.vue?vue&type=style&index=0&id=2a6dbb1b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports